enum TimerStatus {
  Paused = 'Paused',
  Running = 'Running',
  Stopped = 'Stopped',
}
export default TimerStatus;
